import { DropDown } from "./index";

export const SectorDropDown = (props) => {
  return <DropDown label="Sector" name="sector" options={options} {...props} />;
};

const options = ["airline", "corporate"];
